<template>
  <div>
    <div class="row px-2 pt-2">
      <div class="flex md12">
        <div class="row px-2 pt-2">
          <div class="flex md10">
            <h6 :style="{ color: $themes.primary }">Contacts</h6>
          </div>
          <div class="flex md2">
            <div class="row row-inside align-right">
              <va-button color="info" @click="createNewContact" icon="fa fa-plus" />
              <h4 style="position: relative;
          top: 0.6em;">Ajouter un contact</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row px-2 pt-2" v-if="contactList.length">
        <div class="flex md12">
          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="contactList"
            no-data-label="Aucun contact pour ce partenaire"
            clickable
            @row-clicked="modifyContact"
          >
            <template slot="nom_cust" slot-scope="props">
              <p>{{props.rowData.nom?props.rowData.nom:"&nbsp;"}}</p>
              <p class="small_font">{{props.rowData.nom_societe}}</p>
            </template>
            <template slot="prenom_cust" slot-scope="props">
              <p>{{props.rowData.prenom?props.rowData.prenom:"&nbsp;"}}</p>
              <p class="small_font">{{props.rowData.prenom_societe}}</p>
            </template>
            <template slot="titre_cust" slot-scope="props">
              <p>{{props.rowData.titre?props.rowData.titre:"&nbsp;"}}</p>
              <p class="small_font">{{props.rowData.titre_societe}}</p>
            </template>
            <template slot="telephone_cust" slot-scope="props">
              <p>{{formatPhoneNumber(props.rowData.telephone)}}</p>
              <p>{{formatPhoneNumber(props.rowData.portable)}}</p>
            </template>
            <template slot="gerant" slot-scope="props">
              <va-button
                class="modify-etablissement-row"
                flat
                :color="props.rowData.isMain===1?'primary':'secondary'"
                icon="fa fa-user"
                @click="changeMainContact(props.rowData)"
              />
            </template>
          </va-data-table>
        </div>
      </div>
    </div>

    <va-modal
      :title="editTitle"
      class="modal"
      v-model="showEditorContact"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveContact"
      v-on:cancel="closeModal"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex md6">
              <p>Partenaire: {{partenaire.nom}}</p>
            </div>
          </div>
          <div class="row row-inside mt-3">
            <div class="flex md3 padded-input">
              <va-select
                label="Civilité"
                v-model="activeContact.titre"
                :options="titreOptions"
                no-clear
              />
            </div>
            <div class="flex md5 padded-input">
              <va-input v-model="activeContact.nom" placeholder="-" label="Nom" :error="validName" />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-show="activeContact.titre!=='SOCIÉTÉ'"
                :disabled="activeContact.titre==='SOCIÉTÉ'"
                v-model="activeContact.prenom"
                placeholder="-"
                label="Prénom"
              />
            </div>
          </div>
          <div class="row row-inside" v-if="activeContact.titre==='SOCIÉTÉ'">
            <div class="flex md3 padded-input">
              <va-select
                label="Civilité"
                v-model="activeContact.titre_societe"
                :options="titreOptionsSociete"
                no-clear
              />
            </div>
            <div class="flex md5 padded-input">
              <va-input v-model="activeContact.nom_societe" placeholder="-" label="Nom contact" />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-model="activeContact.prenom_societe"
                placeholder="-"
                label="Prénom contact"
              />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md4 padded-input">
              <va-select
                label="Fonction"
                v-model="activeContact.fonction"
                :options="fonctionOptions"
              />
            </div>
            <div class="flex md2 padded-input">
              <va-input
                v-model="phoneNumber"
                placeholder="Telephone"
                label="Telephone"
                :error="validFPhone"
                v-on:paste="trimOnPaste('telephone')"
                v-on:focus="phoneNumber = removeWhiteSpace(phoneNumber)"
                v-on:blur="phoneNumber = formatPhoneNumber(phoneNumber)"
              />
            </div>
            <div class="flex md2 padded-input">
              <va-input
                v-model="portableNumber"
                placeholder="Portable"
                label="Portable"
                :error="validPPhone"
                v-on:paste="trimOnPaste('portable')"
                v-on:focus="portableNumber = removeWhiteSpace(portableNumber)"
                v-on:blur="portableNumber = formatPhoneNumber(portableNumber)"
              />
            </div>
            <div class="flex md4 padded-input">
              <va-input v-model="activeContact.titre_honorifique" placeholder="-" label="Titre" />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md6 padded-input">
              <va-input v-model="activeContact.email" placeholder="-" label="Courriel" />
            </div>

            <div class="flex md3 padded-input">
              <va-toggle small v-model="activeContact.isactif" label="Contact actif" />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md12">
              <va-input
                v-model="activeContact.note"
                label="Commentaire:"
                type="textarea"
                autosize
                :minRows="5"
                :maxRows="5"
              />
            </div>
          </div>
          <va-checkbox label="Adresse du partenaire" v-model="ptAdresse" />
          <dashboard-adresse-infos
            ref="adresseInfoComp"
            class="mt-3"
            :adresseInfos="activeAdresse"
            :isDisabled="ptAdresse"
            v-on:infosChanged="updateInfosA"
          />
          <div class="flex md12">
            <va-button
              v-if="isAdmin && !activeContact.isMain"
              v-show="activeContact.idcontacts_partenaire"
              class="fullwidth"
              large
              color="danger"
              @click="showConfirmDelete = true; toDelete = 'contact'"
            >Supprimer le contact</va-button>
          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer ce contact"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteObject()"
    />

    <va-modal
      class="modal"
      v-model="showJournal"
      cancelClass="none"
      okText="Fermer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveJournal"
      v-on:cancel="closeJournal"
      title="Abonnement Journal"
    >
      <div class="row">
        <div class="flex md12">
          <va-date-picker
            class="warning-date px-2"
            :config="{ dateFormat: 'd-m-Y' }"
            label="Date de fin d’adbonnement"
            v-model="dateFinJournal"
          />
        </div>
        <div class="flex md12">
          <va-button
            class="fullwidth"
            small
            color="danger"
            @click="dateFinJournal=null"
          >Supprimer l’abonnement</va-button>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex, orderBy, isEqual } from "lodash";
import DashboardAdresseInfos from "./DashboardAdresseInfos";
import { isPhoneNumber } from "../../services/utils";

export default {
  name: "contactManager",
  components: {
    DashboardAdresseInfos
  },
  props: ["partenaire", "adresse_partenaire"],

  data() {
    return {
      idcontacts_partenaireJournal: null,
      dateFinJournal: null,
      showJournal: false,
      contactList: [],
      portableNumber: null,
      phoneNumber: null,
      inputSiret: null,
      showConfirmDelete: false,
      toDelete: null,
      isAction: false,
      ptAdresse: true,
      journaltoggle: true,
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      editTitle: "Fiche contact",
      showEditorContact: false,
      activeAdresse: this.resetAdresse(),
      activeAdresseMod: this.resetAdresse(),
      activeContact: this.resetContact(),
      activeContactComp: this.resetContact(),
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
      fonctionOptions: [
        "Président",
        "Gérant",
        "Co-gérant",
        "Ancien Gérant",
        "Directeur général",
        "DRH",
        "Expert-comptable",
        "Comptable",
        "Service Qualité",
        "Autre"
      ]
    };
  },
  mounted() {},
  computed: {
    ctFormNotValid: function() {
      // true :  not valid false: valid

      return this.validName || this.validFPhone || this.validPPhone;
    },

    validName: function() {
      if (!this.activeContact.nom) return true;
      return false;
    },
    validFPhone: function() {
      if (this.activeContact.telephone) {
        return !isPhoneNumber(this.activeContact.telephone);
      }
      return false;
    },
    validPPhone: function() {
      if (this.activeContact.portable) {
        return !isPhoneNumber(this.activeContact.portable);
      }
      return false;
    },
    fields() {
      return [
        {
          name: "__slot:gerant",
          title: "Gérant",
          width: "5%"
        },
        {
          name: "__slot:titre_cust",
          title: "Titre"
          //width: "20%"
        },
        {
          name: "__slot:nom_cust",
          title: "Nom",
          sortField: "nom"
          //width: "20%"
        },
        {
          name: "__slot:prenom_cust",
          title: "Prenom"
          //width: "20%"
        },

        {
          name: "__slot:journal",
          title: "Envoyer journal"
          //width: "15%"
        },
        {
          name: "fonction",
          title: "Fonction"
          //width: "15%"
        },
        {
          name: "__slot:telephone_cust",
          title: "Téléphone"
          //width: "15%"
        },
        {
          name: "email",
          title: "Courriel"
          //width: "15%"
        },
        {
          name: "note",
          title: "Note"
          //width: "15%"
        },
        {
          name: "__slot:statut",
          title: "Actif"
          //width: "15%"
        }
      ];
    }
  },
  methods: {
    async openJournal(idcontacts_partenaire) {
      this.idcontacts_partenaireJournal = idcontacts_partenaire;
      this.isAction = true;
      this.dateFinJournal = null;
      let results = await axios.get("/api/partenaires/contacts/journal", {
        params: {
          idcontacts_partenaire: idcontacts_partenaire
        }
      });

      console.log(results.data);

      if (results.data.length > 0) {
        this.dateFinJournal = results.data[0].date_fin;
      }

      this.showJournal = true;
    },
    async saveJournal() {
      let params = {
        dateFinJournal: this.dateFinJournal,
        idcontact: this.idcontacts_partenaireJournal
      };
      await axios.post("/api/partenaires/journal-contact", params);

      this.idcontacts_partenaireJournal = null;
      this.loadAll(this.partenaire.idpartenaire);
    },
    closeJournal() {
      this.dateFinJournal = this.dateFinJournalSave;
    },
    trimOnPaste(entry) {
      if (entry == "siret") {
        setTimeout(() => {
          this.inputSiret = this.removeWhiteSpace(this.inputSiret);
        }, 200);
      }
      if (entry == "telephone") {
        setTimeout(() => {
          this.phoneNumber = this.removeWhiteSpace(this.phoneNumber);
        }, 200);
      }
      if (entry == "portable") {
        setTimeout(() => {
          this.portableNumber = this.removeWhiteSpace(this.portableNumber);
        }, 200);
      }
    },
    formatSiret() {
      if (!this.validSiret && this.inputSiret) {
        let siret = this.removeWhiteSpace(this.inputSiret);
        this.activeEtablissement.siret = siret;

        // 3 3 3 puis 5

        this.inputSiret =
          siret.slice(0, 3) +
          " " +
          siret.slice(3, 6) +
          " " +
          siret.slice(6, 9) +
          " " +
          siret.slice(9, 14);
      }
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (str && isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
    async loadAll() {
      try {
        let results = await axios.get("/api/partenaire/contacts", {
          params: {
            idpartenaire: this.partenaire.idpartenaire
          }
        });

        results.data.forEach(element => {
          element.isMain =
            element.idcontacts_partenaire === this.partenaire.idcontact ? 1 : 0;
          element.isactif =
            element.isactif === null
              ? true
              : element.isactif === 1
              ? true
              : false;
        });
        results.data = orderBy(results.data, "isMain", "desc");
        this.contactList = results.data;
        console.log(this.contactList);
      } catch (error) {
        console.log("loading list", error);
        this.launchEpicmaxToast(
          "Erreur lors de la lecture de la liste des contacts"
        );
      }
    },
    async saveContact() {
      this.showEditorContact = true;
      if (this.ctFormNotValid) {
        this.launchEpicmaxToast("Formulaire non valide");
        return;
      }
      try {
        if (this.activeContact.titre === "SOCIÉTÉ") {
          this.activeContact.prenom = null;
        }
        console.log(this.activeContact);
        // check that needed fields are set
        if (this.activeContact.idcontacts_partenaire) {
          //update
          let params = {
            contact: this.activeContact,
            adresse: this.activeAdresseMod,
            useOwnAdresse: !this.ptAdresse
          };
          await axios.post("/api/partenaires/update-contact", params);
        } else {
          // create
          this.activeContact.idpartenaire = this.partenaire.idpartenaire;

          let params = {
            contact: this.activeContact,
            adresse: this.activeAdresseMod,
            useOwnAdresse: !this.ptAdresse
          };
          await axios.post("/api/partenaires/create-contact", params);
        }
        if (this.activeContact.isMain === 1) {
          this.$emit("updateContact");
        }
        this.showEditorContact = false;
        let preload = this.loadAll();
        this.activeAdresse = this.resetAdresse();
        this.activeContact = this.resetContact();
        await preload;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors de la sauvegarde - vérifier le formulaire"
        );
        console.log(error);
      }
    },
    async changeMainContact(contact) {
      this.isAction = true;
      try {
        if (contact.idcontacts_partenaire && contact.idpartenaire) {
          await axios.post("/api/partenaires/main-contact", {
            contact: contact
          });
        }
        // modify the table without reload.
        this.contactList.forEach(element => {
          if (element.idcontacts_partenaire === contact.idcontacts_partenaire) {
            element.isMain = 1;
          } else {
            element.isMain = 2;
          }
        });
        this.$emit("updateContact");
      } catch (error) {
        console.log(error);
      }
    },
    modifyContact(contact) {
      this.editTitle = "Fiche contact";
      if (this.isAction) {
        this.isAction = false;
        return;
      }
      this.ptAdresse = false;
      this.activeContact = this.resetContact(contact);

      //own adresse or etablissement
      if (contact.idadresse) {
        this.activeAdresse = cloneDeep(this.resetAdresse(contact));
      } else {
        this.ptAdresse = true;
        this.activeAdresse = cloneDeep(this.adresse_partenaire);
      }
      this.activeAdresseMod = cloneDeep(this.activeAdresse);
      this.phoneNumber = this.activeContact.telephone
        ? this.formatPhoneNumber(this.activeContact.telephone)
        : null;
      this.portableNumber = this.activeContact.portable
        ? this.formatPhoneNumber(this.activeContact.portable)
        : null;
      this.showEditorContact = true;
    },

    resetAdresse(value) {
      let adresse;
      if (value) {
        adresse = {
          id: value.idadresse,
          code_postal: value.code_postal,
          ville: value.ville,
          adresse: value.adresse,
          complement: value.complement,
          cedex: value.cedex
        };
      } else {
        adresse = {
          id: null,
          code_postal: null,
          ville: null,
          adresse: null,
          complement: null,
          cedex: null
        };
      }
      return adresse;
    },
    resetContact(value) {
      let contact = {
        isMain: false,
        idcontacts_partenaire: null,
        idpartenaire: this.partenaire.idpartenaire,
        telephone: null,
        portable: null,
        email: null,
        idadresse: null,
        note: null,
        fonction: null,
        titre: null,
        nom: null,
        prenom: null,
        titre_societe: null,
        nom_societe: null,
        prenom_societe: null,
        isactif: true,
        titre_honorifique: null
      };
      if (value) {
        contact = {
          isMain: value.isMain,
          idcontacts_partenaire: value.idcontacts_partenaire,
          idpartenaire: value.idpartenaire,
          telephone: value.telephone,
          portable: value.portable,
          email: value.email,
          idadresse: value.idadresse,
          note: value.note,
          fonction: value.fonction,
          titre: value.titre,
          nom: value.nom,
          prenom: value.prenom,
          titre_societe: value.titre_societe,
          nom_societe: value.nom_societe,
          prenom_societe: value.prenom_societe,
          isactif: value.isactif,
          titre_honorifique: value.titre_honorifique
        };
      }

      return contact;
    },
    updateInfosA() {
      this.activeAdresseMod = cloneDeep(
        this.$refs.adresseInfoComp.adresseInfosMod
      );
    },
    createNewContact() {
      this.editTitle = "Créer un nouveau contact";

      this.activeContact = this.resetContact();
      this.activeAdresse = cloneDeep(this.adresse_partenaire);
      this.activeAdresseMod = cloneDeep(this.adresse_partenaire);
      this.showEditorContact = true;
      this.phoneNumber = null;
      this.portableNumber = null;
    },
    closeModal() {
      this.activeAdresse = this.resetAdresse();
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },
    async deleteObject() {
      try {
        await axios.delete("/api/partenaires/delete-contact", {
          data: {
            idcontacts_partenaire: this.activeContact.idcontacts_partenaire
          }
        });
        this.showEditorContact = false;
        this.activeContact = this.resetContact();
        this.activeAdresse = this.resetAdresse();
        this.loadAll();
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    phoneNumber(newNumber) {
      if (newNumber) {
        this.activeContact.telephone = this.removeWhiteSpace(newNumber);
      }
    },
    portableNumber(newNumber) {
      if (newNumber) {
        this.activeContact.portable = this.removeWhiteSpace(newNumber);
      }
    },

    ptAdresse(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.activeAdresse = this.adresse_partenaire;
      }
      if (!newValue && oldValue) {
        // this.activeAdresse = this.resetAdresse();
      }
    },

    partenaire(newpartenaire) {
      if (newpartenaire) {
        this.loadAll();
      } else {
      }
    }
  }
};
</script>

<style lang="scss">
.padded-input {
  padding-left: 0.25rem;
}
.modify-etablissement-row {
  top: 0.5em;
}
.forcewidth-create-contact {
  width: 75vw;
  height: 60vh;
}

.large_font {
  font-size: 1.1em;
}
.small_font {
  font-size: 0.8em;
}
</style>
